import React from 'react';

const ManageProducts = () => {
    return (
        <div>
            <h1>manaeg eekd </h1>
        </div>
    );
};

export default ManageProducts;